"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.mediaOnly = exports.mediaMin = exports.mediaMax = exports.default = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _styled = require("../styled");
var _breakpoints = require("./breakpoints");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
// Define only queries that spans between min-width and max-width
var mediaOnly = exports.mediaOnly = {
  xxs: function xxs() {
    return (0, _styled.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    @media (max-width: ", "px) {\n      ", ";\n    }\n  "])), _breakpoints.maxBreakpoints.xs, _styled.css.apply(void 0, arguments));
  },
  xs: function xs() {
    return (0, _styled.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n    @media (min-width: ", "px) and (max-width: ", "px) {\n      ", ";\n    }\n  "])), _breakpoints.minBreakpoints.xs, _breakpoints.maxBreakpoints.sm, _styled.css.apply(void 0, arguments));
  },
  sm: function sm() {
    return (0, _styled.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n    @media (min-width: ", "px) and (max-width: ", "px) {\n      ", ";\n    }\n  "])), _breakpoints.minBreakpoints.sm, _breakpoints.maxBreakpoints.md, _styled.css.apply(void 0, arguments));
  },
  md: function md() {
    return (0, _styled.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteralLoose2.default)(["\n    @media (min-width: ", "px) and (max-width: ", "px) {\n      ", ";\n    }\n  "])), _breakpoints.minBreakpoints.md, _breakpoints.maxBreakpoints.lg, _styled.css.apply(void 0, arguments));
  },
  lg: function lg() {
    return (0, _styled.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteralLoose2.default)(["\n    @media (min-width: ", "px) and (max-width: ", "px) {\n      ", ";\n    }\n  "])), _breakpoints.minBreakpoints.lg, _breakpoints.maxBreakpoints.xl, _styled.css.apply(void 0, arguments));
  },
  xl: function xl() {
    return (0, _styled.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteralLoose2.default)(["\n    @media (min-width: ", "px) and (max-width: ", "px) {\n      ", ";\n    }\n  "])), _breakpoints.minBreakpoints.xl, _breakpoints.maxBreakpoints.xxl, _styled.css.apply(void 0, arguments));
  },
  xxl: function xxl() {
    return (0, _styled.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteralLoose2.default)(["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "])), _breakpoints.minBreakpoints.xxl, _styled.css.apply(void 0, arguments));
  }
};

// Iterate through the sizes and create a media template for min-width queries
var mediaMin = exports.mediaMin = Object.keys(_breakpoints.minBreakpoints).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styled.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteralLoose2.default)(["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "])), _breakpoints.minBreakpoints[label], _styled.css.apply(void 0, arguments));
  };
  return acc;
}, {});

// Iterate through the sizes and create a media template for max-width queries
var mediaMax = exports.mediaMax = Object.keys(_breakpoints.maxBreakpoints).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styled.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteralLoose2.default)(["\n    @media (max-width: ", "px) {\n      ", ";\n    }\n  "])), _breakpoints.maxBreakpoints[label], _styled.css.apply(void 0, arguments));
  };
  return acc;
}, {});
var mediaQueries = {
  only: mediaOnly,
  min: mediaMin,
  max: mediaMax
};
var _default = exports.default = mediaQueries;